import PropTypes from 'prop-types';
import '@css/PopUp.css';

const ALTERNATIVE_STORE_URL = 'https://auringontalo.fi/chess-web/';

const BillingUnavailable = ({ onClose, showCloseButton = true }) => {
    return (
        <div className="subscription-unavailable">
            <h3>Оплата временно недоступна</h3>
            <p>
                К сожалению, функция оплаты временно отключена. Пожалуйста, попробуйте позже.
            </p>
            <p>
                Вы можете оформить подписку в альтернативном магазине:{' '}
                <a
                    href={ALTERNATIVE_STORE_URL}
                    target="_blank"
                    rel="noreferrer"
                >
                    auringontalo.fi/chess-web
                </a>
            </p>
            <div className="pricing-actions">
                {showCloseButton ? (
                    <button
                        className="btn-cancel"
                        onClick={onClose}
                    >
                        Закрыть
                    </button>
                ) : null}
            </div>
        </div>
    );
};

BillingUnavailable.propTypes = {
    onClose: PropTypes.func,
    showCloseButton: PropTypes.bool,
};

export default BillingUnavailable;
